export const truncateString = (s = '', maxLength = 50) =>
  s?.length > maxLength ? `${s.slice(0, maxLength)}...` : s;
